/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Logout_viewer$ref = any;
type Order_viewer$ref = any;
type SideNav_viewer$ref = any;
export type routes_Order_QueryVariables = {|
  orderNames: $ReadOnlyArray<string>
|};
export type routes_Order_QueryResponse = {|
  +viewer: ?{|
    +email: ?string,
    +stores: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
          +phone: ?string,
        |}
      |}>
    |},
    +salesOrders: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
          +shippingTotal: ?number,
          +verified: ?number,
          +verificationLink: ?string,
          +shippingDescription: ?string,
          +paymentDescription: ?string,
          +subtotal: ?number,
          +grandTotal: ?number,
          +insertedAt: ?string,
          +surcharge: ?number,
          +surcharges: ?$ReadOnlyArray<?{|
            +name: ?string,
            +amount: ?number,
          |}>,
          +discount: ?number,
          +discounts: ?$ReadOnlyArray<?{|
            +id: ?string,
            +name: ?string,
            +code: ?string,
            +amount: ?number,
          |}>,
          +shipments: ?any,
          +shippingStatus: ?string,
          +status: ?number,
          +addresses: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +addressType: ?string,
                +firstname: ?string,
                +lastname: ?string,
                +street: ?string,
                +city: ?string,
                +postcode: ?string,
                +region: ?string,
                +country: ?{|
                  +name: ?string
                |},
                +telephone: ?string,
                +company: ?string,
                +fax: ?string,
                +editable: ?boolean,
              |}
            |}>
          |},
          +lines: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +quantity: ?number,
                +unitPrice: ?number,
                +unitDiscount: ?number,
                +unitSurcharge: ?number,
                +rowTotal: ?number,
                +configParent: ?{|
                  +id: string,
                  +urlSlug: ?string,
                  +mainImage: ?{|
                    +id: string,
                    +thumbnail: ?string,
                  |},
                |},
                +priorityShipping: ?{|
                  +getByDate: ?string
                |},
                +product: ?{|
                  +urlSlug: ?string,
                  +status: ?string,
                  +mainImage: ?{|
                    +id: string,
                    +url: ?string,
                    +thumbnail: ?string,
                  |},
                |},
                +shipments: ?$ReadOnlyArray<?{|
                  +tracking: ?any,
                  +location: ?string,
                  +status: ?string,
                  +timestamp: ?string,
                |}>,
                +children: ?{|
                  +edges: ?$ReadOnlyArray<?{|
                    +node: ?{|
                      +id: string,
                      +name: ?string,
                      +quantity: ?number,
                      +unitPrice: ?number,
                      +unitDiscount: ?number,
                      +unitSurcharge: ?number,
                      +rowTotal: ?number,
                      +product: ?{|
                        +urlSlug: ?string,
                        +status: ?string,
                        +mainImage: ?{|
                          +id: string,
                          +url: ?string,
                          +thumbnail: ?string,
                        |},
                      |},
                      +shipments: ?$ReadOnlyArray<?{|
                        +tracking: ?any,
                        +location: ?string,
                        +status: ?string,
                        +timestamp: ?string,
                      |}>,
                    |}
                  |}>
                |},
              |}
            |}>
          |},
        |}
      |}>
    |},
    +$fragmentRefs: Order_viewer$ref & SideNav_viewer$ref & Logout_viewer$ref,
  |}
|};
export type routes_Order_Query = {|
  variables: routes_Order_QueryVariables,
  response: routes_Order_QueryResponse,
|};
*/


/*
query routes_Order_Query(
  $orderNames: [String!]!
) {
  viewer {
    ...Order_viewer
    email
    stores(first: 999) {
      edges {
        node {
          id
          name
          phone
        }
      }
    }
    salesOrders(first: 1, orderNames: $orderNames) {
      edges {
        node {
          id
          name
          shippingTotal
          verified
          verificationLink
          shippingDescription
          paymentDescription
          subtotal
          grandTotal
          insertedAt
          surcharge
          surcharges {
            name
            amount
          }
          discount
          discounts {
            id
            name
            code
            amount
          }
          shipments
          shippingStatus
          status
          addresses(first: 2) {
            edges {
              node {
                id
                addressType
                firstname
                lastname
                street
                city
                postcode
                region
                country {
                  name
                }
                telephone
                company
                fax
                editable
              }
            }
          }
          lines(first: 99) {
            edges {
              node {
                id
                name
                quantity
                unitPrice
                unitDiscount
                unitSurcharge
                rowTotal
                configParent {
                  id
                  urlSlug
                  mainImage {
                    id
                    thumbnail
                  }
                }
                priorityShipping {
                  getByDate
                }
                product {
                  urlSlug
                  status
                  mainImage {
                    id
                    url
                    thumbnail
                  }
                  id
                }
                shipments {
                  tracking
                  location
                  status
                  timestamp
                }
                children(first: 99) {
                  edges {
                    node {
                      id
                      name
                      quantity
                      unitPrice
                      unitDiscount
                      unitSurcharge
                      rowTotal
                      product {
                        urlSlug
                        status
                        mainImage {
                          id
                          url
                          thumbnail
                        }
                        id
                      }
                      shipments {
                        tracking
                        location
                        status
                        timestamp
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    ...SideNav_viewer
    ...Logout_viewer
    id
  }
}

fragment Logout_viewer on Customer {
  email
}

fragment Order_viewer on Customer {
  email
  stores(first: 999) {
    edges {
      node {
        id
        name
        phone
      }
    }
  }
  salesOrders(first: 1, orderNames: $orderNames) {
    edges {
      node {
        id
        name
        shippingTotal
        verified
        verificationLink
        shippingDescription
        paymentDescription
        subtotal
        grandTotal
        insertedAt
        surcharge
        surcharges {
          name
          amount
        }
        discount
        discounts {
          id
          name
          code
          amount
        }
        shipments
        shippingStatus
        status
        addresses(first: 2) {
          edges {
            node {
              id
              addressType
              firstname
              lastname
              street
              city
              postcode
              region
              country {
                name
              }
              telephone
              company
              fax
              editable
            }
          }
        }
        lines(first: 99) {
          edges {
            node {
              id
              name
              quantity
              unitPrice
              unitDiscount
              unitSurcharge
              rowTotal
              configParent {
                id
                urlSlug
                mainImage {
                  id
                  thumbnail
                }
              }
              priorityShipping {
                getByDate
              }
              product {
                urlSlug
                status
                mainImage {
                  id
                  url
                  thumbnail
                }
                id
              }
              shipments {
                tracking
                location
                status
                timestamp
              }
              children(first: 99) {
                edges {
                  node {
                    id
                    name
                    quantity
                    unitPrice
                    unitDiscount
                    unitSurcharge
                    rowTotal
                    product {
                      urlSlug
                      status
                      mainImage {
                        id
                        url
                        thumbnail
                      }
                      id
                    }
                    shipments {
                      tracking
                      location
                      status
                      timestamp
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

fragment SideNav_viewer on Customer {
  email
  ...Logout_viewer
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderNames"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 999
    }
  ],
  "concreteType": "StoreConnection",
  "kind": "LinkedField",
  "name": "stores",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phone",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "stores(first:999)"
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "orderNames",
    "variableName": "orderNames"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shippingTotal",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verified",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verificationLink",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shippingDescription",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentDescription",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtotal",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grandTotal",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insertedAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surcharge",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderSurcharge",
  "kind": "LinkedField",
  "name": "surcharges",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Discount",
  "kind": "LinkedField",
  "name": "discounts",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    (v15/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shipments",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shippingStatus",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 2
    }
  ],
  "concreteType": "SalesAddressConnection",
  "kind": "LinkedField",
  "name": "addresses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesAddressEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesAddress",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addressType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstname",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastname",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "street",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "postcode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "region",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Country",
              "kind": "LinkedField",
              "name": "country",
              "plural": false,
              "selections": [
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "telephone",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "company",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fax",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "editable",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "addresses(first:2)"
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitPrice",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitDiscount",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitSurcharge",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowTotal",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "configParent",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v29/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductImage",
      "kind": "LinkedField",
      "name": "mainImage",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "PriorityShipping",
  "kind": "LinkedField",
  "name": "priorityShipping",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "getByDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductImage",
  "kind": "LinkedField",
  "name": "mainImage",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v30/*: any*/)
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v21/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesShipmentLine",
  "kind": "LinkedField",
  "name": "shipments",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tracking",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v21/*: any*/),
    (v33/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_Order_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "SalesOrderConnection",
            "kind": "LinkedField",
            "name": "salesOrders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesOrderEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesOrder",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": (v23/*: any*/),
                        "concreteType": "SalesOrderLineConnection",
                        "kind": "LinkedField",
                        "name": "lines",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SalesOrderLineEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SalesOrderLine",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v23/*: any*/),
                                    "concreteType": "SalesOrderLineConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SalesOrderLineEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SalesOrderLine",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v3/*: any*/),
                                              (v24/*: any*/),
                                              (v25/*: any*/),
                                              (v26/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v34/*: any*/),
                                              (v35/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "children(first:99)"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "lines(first:99)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Order_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SideNav_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Logout_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_Order_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "SalesOrderConnection",
            "kind": "LinkedField",
            "name": "salesOrders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesOrderEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesOrder",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": (v23/*: any*/),
                        "concreteType": "SalesOrderLineConnection",
                        "kind": "LinkedField",
                        "name": "lines",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SalesOrderLineEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SalesOrderLine",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v36/*: any*/),
                                  (v35/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v23/*: any*/),
                                    "concreteType": "SalesOrderLineConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SalesOrderLineEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SalesOrderLine",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v3/*: any*/),
                                              (v24/*: any*/),
                                              (v25/*: any*/),
                                              (v26/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v36/*: any*/),
                                              (v35/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "children(first:99)"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "lines(first:99)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e35593f81dc48b14b4688055c61bef9",
    "id": null,
    "metadata": {},
    "name": "routes_Order_Query",
    "operationKind": "query",
    "text": "query routes_Order_Query(\n  $orderNames: [String!]!\n) {\n  viewer {\n    ...Order_viewer\n    email\n    stores(first: 999) {\n      edges {\n        node {\n          id\n          name\n          phone\n        }\n      }\n    }\n    salesOrders(first: 1, orderNames: $orderNames) {\n      edges {\n        node {\n          id\n          name\n          shippingTotal\n          verified\n          verificationLink\n          shippingDescription\n          paymentDescription\n          subtotal\n          grandTotal\n          insertedAt\n          surcharge\n          surcharges {\n            name\n            amount\n          }\n          discount\n          discounts {\n            id\n            name\n            code\n            amount\n          }\n          shipments\n          shippingStatus\n          status\n          addresses(first: 2) {\n            edges {\n              node {\n                id\n                addressType\n                firstname\n                lastname\n                street\n                city\n                postcode\n                region\n                country {\n                  name\n                }\n                telephone\n                company\n                fax\n                editable\n              }\n            }\n          }\n          lines(first: 99) {\n            edges {\n              node {\n                id\n                name\n                quantity\n                unitPrice\n                unitDiscount\n                unitSurcharge\n                rowTotal\n                configParent {\n                  id\n                  urlSlug\n                  mainImage {\n                    id\n                    thumbnail\n                  }\n                }\n                priorityShipping {\n                  getByDate\n                }\n                product {\n                  urlSlug\n                  status\n                  mainImage {\n                    id\n                    url\n                    thumbnail\n                  }\n                  id\n                }\n                shipments {\n                  tracking\n                  location\n                  status\n                  timestamp\n                }\n                children(first: 99) {\n                  edges {\n                    node {\n                      id\n                      name\n                      quantity\n                      unitPrice\n                      unitDiscount\n                      unitSurcharge\n                      rowTotal\n                      product {\n                        urlSlug\n                        status\n                        mainImage {\n                          id\n                          url\n                          thumbnail\n                        }\n                        id\n                      }\n                      shipments {\n                        tracking\n                        location\n                        status\n                        timestamp\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    ...SideNav_viewer\n    ...Logout_viewer\n    id\n  }\n}\n\nfragment Logout_viewer on Customer {\n  email\n}\n\nfragment Order_viewer on Customer {\n  email\n  stores(first: 999) {\n    edges {\n      node {\n        id\n        name\n        phone\n      }\n    }\n  }\n  salesOrders(first: 1, orderNames: $orderNames) {\n    edges {\n      node {\n        id\n        name\n        shippingTotal\n        verified\n        verificationLink\n        shippingDescription\n        paymentDescription\n        subtotal\n        grandTotal\n        insertedAt\n        surcharge\n        surcharges {\n          name\n          amount\n        }\n        discount\n        discounts {\n          id\n          name\n          code\n          amount\n        }\n        shipments\n        shippingStatus\n        status\n        addresses(first: 2) {\n          edges {\n            node {\n              id\n              addressType\n              firstname\n              lastname\n              street\n              city\n              postcode\n              region\n              country {\n                name\n              }\n              telephone\n              company\n              fax\n              editable\n            }\n          }\n        }\n        lines(first: 99) {\n          edges {\n            node {\n              id\n              name\n              quantity\n              unitPrice\n              unitDiscount\n              unitSurcharge\n              rowTotal\n              configParent {\n                id\n                urlSlug\n                mainImage {\n                  id\n                  thumbnail\n                }\n              }\n              priorityShipping {\n                getByDate\n              }\n              product {\n                urlSlug\n                status\n                mainImage {\n                  id\n                  url\n                  thumbnail\n                }\n                id\n              }\n              shipments {\n                tracking\n                location\n                status\n                timestamp\n              }\n              children(first: 99) {\n                edges {\n                  node {\n                    id\n                    name\n                    quantity\n                    unitPrice\n                    unitDiscount\n                    unitSurcharge\n                    rowTotal\n                    product {\n                      urlSlug\n                      status\n                      mainImage {\n                        id\n                        url\n                        thumbnail\n                      }\n                      id\n                    }\n                    shipments {\n                      tracking\n                      location\n                      status\n                      timestamp\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SideNav_viewer on Customer {\n  email\n  ...Logout_viewer\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2741655b7edf69a00ac3ca3e44772eb1';

module.exports = node;
